import React, { useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import Logo from "../assets/logo.webp";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
export default function SignIn() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showForgot, setShowForgot] = useState(false);
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const handleLogin = (e) => {
        e.preventDefault();
        // alert(`Login with Email: ${email} Password: ${password}`);
        navigate("/user-dashboard");
    };
    const handleForgotNext = () => {
        if (step === 1) {
            if (!mobile || !/^\d{10}$/.test(mobile)) {
                alert("Enter valid 10-digit mobile number");
                return;
            }
            alert(`OTP sent to ${mobile}`);
            setStep(2);
        } else if (step === 2) {
            if (!otp) {
                alert("Enter OTP");
                return;
            }
            alert(`OTP verified: ${otp}`);
            setStep(3);
        } else if (step === 3) {
            if (!newPassword || newPassword.length < 6) {
                alert("Password must be at least 6 characters");
                return;
            }
            alert("Password reset successfully!");
            setShowForgot(false);
            setStep(1);
            setMobile("");
            setOtp("");
            setNewPassword("");
        }
    };
    const handleForgotClose = () => {
        setShowForgot(false);
        setStep(1);
        setMobile("");
        setOtp("");
        setNewPassword("");
    };
    return (
        <div className="page-container">
            <Header />
            <div className="login-right">
                <div className="login-card">
                    <h2 style={{ width: "100%", textAlign: "center" }}>Welcome Back</h2>
                    <div className="gradient-line"></div>
                    <p className="login-subtitle">Sign in to continue Senthan Amuthan</p>
                    <form onSubmit={handleLogin} className="login-form">
                        <div className="input-group">
                            <FaUser className="input-icon" />
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required />
                        </div>
                        <div className="input-group">
                            <FaLock className="input-icon" />
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required />
                        </div>
                        <div className="login-options">
                            <a href="#" onClick={() => setShowForgot(true)}>Forgot Password?</a>
                        </div>
                        <button type="submit" className="login-btn">Login</button>
                        <p className="signup-link">Don’t have an account? <a href="/signup">Sign Up</a></p>
                    </form>
                </div>
            </div>
            {showForgot && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Forgot Password</h3>
                        {step === 1 && (
                            <>
                                <p>Enter your registered mobile number:</p>
                                <input
                                    type="text"
                                    placeholder="Mobile Number"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)} />
                            </>
                        )}
                        {step === 2 && (
                            <>
                                <p>Enter the OTP sent to {mobile}:</p>
                                <input
                                    type="text"
                                    placeholder="OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)} />
                            </>
                        )}
                        {step === 3 && (
                            <>
                                <p>Enter your new password:</p>
                                <input
                                    type="password"
                                    placeholder="New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)} />
                            </>
                        )}
                        <div className="modal-actions">
                            <button className="modal-btn" onClick={handleForgotNext}>{step === 3 ? "Reset Password" : "Next"}</button>
                            <button className="modal-btn cancel" onClick={handleForgotClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
}